import { Component, Input, ViewChild } from '@angular/core';
import { EntityArt } from '@enums/entityArt.enum';
import { DokumenteComponent } from '@shared/dokumente/dokumente.component';


@Component({
    selector: 'cz-dokument-popup',
    templateUrl: 'dokumente-popup.component.html',
    styleUrls: ['./dokumente-popup.component.css'],
    standalone: false
})
export class DokumentPopupComponent {

    @ViewChild('dokComp', { static: false }) docComp: DokumenteComponent;
    popupVisible: boolean;

    @Input() ownerId: number;
    @Input() entityArt: EntityArt;

    loading = false;

    constructor() {
        this.hidePopup = this.hidePopup.bind(this);
    }

    onShowingPopup(event) {
        setTimeout(() => {
            this.docComp.refreshDocuments(null);
        }, 0);
    }

    showPopup() {
        this.popupVisible = true;
    }

    hidePopup() {
        this.popupVisible = false;
    }
}
